<template>
  <div class="pm-list">
    <!-- 左侧菜单栏 -->
    <div class="pm-list-menu">
      <div class="menu-content">
        <div class="category-title">项目</div>
        <div class="category-list">
          <div :class="activeTab == 'star' && 'active'" class="item" @click="switchTab('star')">
            <span class="icon top1"><i class="el-icon-star-off font-16"></i></span>
            <span class="ellipsis">星标项目</span>
          </div>
          <div :class="activeTab == 'archive' && 'active'" class="item" @click="switchTab('archive')">
            <span class="icon top1"><i class="el-icon-folder-opened font-16"></i></span>
            <span class="ellipsis">归档项目</span>
          </div>
          <div :class="activeTab == 'recycle' && 'active'" class="item" @click="switchTab('recycle')">
            <span class="icon top1"><i class="el-icon-delete font-16"></i></span>
            <span class="ellipsis">项目回收站</span>
          </div>
          <div :class="activeTab == 'all' && 'active'" class="item item-all" @click="switchTab('all')">
            <span class="icon top1"><i class="el-icon-menu font-16"></i></span>
            <span class="ellipsis">全部项目</span>
          </div>
        </div>
      </div>
      <div class="group-content">
        <div :class="activeTab == indexGroup.groupid && 'active'" class="index" @click="switchTab(indexGroup)">
          <span>{{ indexGroup.name }}</span>
        </div>
        <div class="group-list">
          <draggable v-model="groupList" handle=".move-icon" @change="handleDraggableChange">
            <transition-group>
              <div v-for="group in groupList" :key="group.groupid" :class="activeTab == group.groupid && 'active'"
                class="item" @click="switchTab(group)">
                <span v-if="user.is_owner||1" class="move-icon"><i class="el-icon-rank font-16"></i></span>
                <span class="name ellipsis">{{ group.name }}</span>
                <CommonMore v-if="user.is_owner||1" :list="moreOpts" @change="handleMenuMoreChange(group, $event)" />
              </div>
            </transition-group>
          </draggable>
        </div>
        <div v-if="user.is_owner||1" class="add-btn" @click="showAddGroup">
          <i class="el-icon-plus font-16 text-bold icon"></i>
          <span class="top1">添加分组</span>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="pm-list-container">
      <div class="container-header">
        <span class="text-bold">{{ activeTitle }}</span>
        <span class="text-muted">（{{ activeCount }}）</span>
      </div>

      <!-- 工具栏 -->
      <div class="container-toolbox">
        <div class="flex justify-content-space-between align-items-center">
          <el-button v-if="activeTab != 'star' && activeTab != 'archive' && activeTab != 'recycle'" type="success"
            icon="el-icon-plus" @click="handleAddProjectShow">新建项目</el-button>
          <span v-else-if="activeTab == 'star'" class="info-class text-muted">重点关注的项目，可添加星标</span>
          <span v-else-if="activeTab == 'archive'" class="info-class text-muted">归档项目，将不可被更改数据、实时统计、删除等编辑操作，仅可查看</span>
          <span v-else-if="activeTab == 'recycle'" class="info-class warning flex align-items-center">
            <i class="el-icon-warning font-16 text-warning mr-sm"></i>
            <span>移至回收站的项目，将在90天后删除，数据不可恢复</span>
          </span>
          <div class="flex">
            <f-search-input v-model="query.keyword" class="mr" @change="handleKeywordChange" />
            <div class="view-switch text-muted">
              <el-tooltip effect="dark" :enterable="false" content="列表视图" placement="top">
                <span role="button" :class="activeView == 'list' && 'active'" class="btn flex-center"
                  @click="switchView('list')"><i class="el-icon-s-operation"></i></span>
              </el-tooltip>
              <el-tooltip effect="dark" :enterable="false" content="卡片视图" placement="top">
                <span role="button" :class="activeView == 'card' && 'active'" class="btn flex-center"
                  @click="switchView('card')"><i class="el-icon-menu"></i></span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>

      <!-- 表格视图 -->
      <el-card v-if="activeView == 'list'" v-loading="dataLoading" class="list-container">
        <el-table ref="listTable" :data="list" size="medium" :highlight-current-row="true" height="100%"
          class="pm-list-table padding-large">
          <el-table-column key="1" label="序号" type="index" width="60"> </el-table-column>

          <el-table-column key="2" label="项目名称" min-width="150" show-overflow-tooltip>
            <div slot-scope="scope" class="project-title">
              <el-link :underline="false" @click="toProjectDetail(scope.row)">{{ scope.row.project_title }}</el-link>
              <CommonMore v-if="activeTab != 'archive'" :list="commonConfig(scope.row)"
                @change="handleMoreChange(scope.row, $event)" />
              <span v-else role="button" class="common-icon-hover align-items-center"
                @click="recoverProject(scope.row)"><i class="el-icon-refresh-right"></i></span>
            </div>
          </el-table-column>

          <el-table-column v-if="activeTab != 'recycle' && activeTab != 'archive'" key="3" label="已完成" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.cnt_task_finished }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab != 'recycle' && activeTab != 'archive'" key="4" label="未完成" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.cnt_task_unfinished }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab != 'recycle' && activeTab != 'archive'" key="5" label="任务总数" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.cnt_task_total }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab != 'recycle' && activeTab != 'archive'" key="6" label="任务进度" min-width="130"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-progress
                :percentage="scope.row.task_finished ? parseInt(100*scope.row.task_finished/scope.row.cnt_task_total) : 0"
                :color="!scope.row.task_finished||scope.row.task_finished/scope.row.cnt_task_total <= 0.3 ? '#997bec' : scope.row.task_finished/scope.row.cnt_task_total <= 0.8 ? '#409eff' : '#07c160'">
              </el-progress>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab == 'recycle'" key="8" label="删除人" width="200" show-overflow-tooltip>
            <template slot-scope="scope" class="flex align-items-center">
              <f-user-avatar :user="{avatar:scope.row.principal_avatar,username:scope.row.principal_username}"
                class="sm mr-xs" :preview="false" size="mini" role="button" />
              <!-- <img v-if="scope.row.principal" :src="scope.row.principal_avatar" alt="" class="image circle sm mr-xs" />
							<img v-else src="@/assets/default-avatar.png" alt="" class="image circle sm mr-xs" /> -->
              <span v-if="scope.row.principal">{{ scope.row.principal_username }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab == 'recycle'" key="7" label="删除时间" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.delete_time | parseTime('{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab == 'archive'" key="10" label="归档人" width="200" show-overflow-tooltip>
            <template slot-scope="scope" class="flex align-items-center">
              <f-user-avatar :user="{avatar:scope.row.principal_avatar,username:scope.row.principal_username}"
                class="sm mr-xs" :preview="false" size="mini" role="button" />
              <!-- <img v-if="scope.row.archiver && scope.row.archiver.principal_avatar" :src="scope.row.archiver.principal_avatar" alt="" class="image circle sm mr-xs" />
							<img v-else src="@/assets/default-avatar.png" alt="" class="image circle sm mr-xs" /> -->
              <span v-if="scope.row.archiver && scope.row.archiver.username">{{ scope.row.archiver.username }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab == 'archive'" key="9" label="归档时间" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.archive_time | parseTime('{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab == 'archive'" key="12" label="任务完成率" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-progress
                :percentage="scope.row.cnt_task_total ? parseInt(100*scope.row.cnt_task_finished/scope.row.cnt_task_total):0"
                :color="parseInt(100*scope.row.cnt_task_finished/scope.row.cnt_task_total) <= 30 ? '#997bec' : parseInt(100*scope.row.cnt_task_finished/scope.row.cnt_task_total) <= 80 ? '#409eff' : '#07c160'">
              </el-progress>
            </template>
          </el-table-column>

          <el-table-column key="18" label="负责人" width="200" show-overflow-tooltip>
            <template slot-scope="scope" class="flex align-items-center">
              <f-user-avatar :user="{uid:scope.row.principal,avatar:scope.row.principal_avatar,username:scope.row.principal_username}"
                class="hd sm mr-xs" :preview="false" size="mini" role="button" />
              <span v-if="scope.row.principal">{{ scope.row.principal_username }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab == 'star'" key="19" label="星标时间" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.star_time | parseTime('{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="activeTab != 'star'" key="20" label="创建时间" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.createtime | parseTime('{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>

          <template slot="empty">
            <img class="image huger mt-lg" src="@/assets/empty.png" />
            <div class="font-md mb-hg">暂无数据</div>
          </template>
        </el-table>
        <div class="table-footer">
          <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize"
            @change="fetchProjectList" />
        </div>
      </el-card>

      <!-- 卡片视图 -->
      <div v-if="activeView == 'card'" v-loading="dataLoading" class="card-container">
        <div v-for="project in list" :key="project.projectid" class="card-item-container">
          <el-card :class="activeStyleId == project.projectid ? 'item-selected' : ''" class="card-item flex column"
            @click.native="toProjectDetail(project)">
            <div class="hd flex justify-content-space-between">
              <span style="height: 24px" class="font-16">{{ project.title }}</span>
              <span class="flex align-items-center">
                <CommonMore v-if="activeTab != 'archive'" :list="commonConfig(project)"
                  @click.native.stop="setActiveStyleId(project.projectid)"
                  @change="handleMoreChange(project, $event)" />
                <span v-if="activeTab != 'archive' && activeTab != 'recycle'" class="ml-sm"
                  @click.stop="starProject(project)">
                  <i v-show="project.star" class="el-icon-star-on text-warning common-icon"></i>
                  <i v-show="!project.star" class="el-icon-star-off common-icon-hover"></i>
                </span>
                <span v-if="activeTab == 'archive'" @click.stop="recoverProject(project)">
                  <i class="el-icon-refresh-right common-icon-hover"></i>
                </span>
              </span>
            </div>
            <div class="bd flex">
              <TaskPie :uncomplete="project.cnt_task_unfinished" :complete="project.cnt_task_finished" class="flex1" />
              <div style="border-left: 2px solid #e7e7e7" class="flex1 flex-center column">
                <div class="task-item mb">
                  <span class="pr">我的任务数</span>
                  <span>{{ project.cnt_task_total }}</span>
                </div>
                <div class="task-item mb">
                  <span class="pr">我已完成数</span>
                  <span>{{ project.cnt_task_finished }}</span>
                </div>
                <div class="task-item">
                  <span class="pr">我未完成数</span>
                  <span>{{ project.cnt_task_unfinished }}</span>
                </div>
              </div>
            </div>
            <div style="border-top: 2px solid #e7e7e7" class="ft flex align-items-center pt-sm mt-xs">
              <f-user-avatar
                :user="{uid:project.principal,avatar:project.principal_avatar,username:project.principal_username}"
                class="hd" :preview="false" size="mini" role="button" />
              <!-- <img v-if="project.principal_avatar" :src="project.principal_avatar" alt="" class="hd image circle mini" />
							<img v-else src="@/assets/default-avatar.png" alt="" class="hd image circle mini" /> -->
              <span v-if="project.principal_username" class="bd pl-sm">{{ project.principal_username }}</span>
              <span class="ft fast-icon">
                <div class="item mr-sm common-icon" @click.stop="toProjectDetail(project, 'deliver')">
                  <i class="iconfont icon-delivery"></i>
                </div>
                <div class="item common-icon" @click.stop="toProjectDetail(project, 'space')">

                  <i class="iconfont icon-space"></i>
                </div>
                <!-- <div class="item ml-sm common-icon">
                    <img src="@/assets/sheet.png" />
                  </div> -->
              </span>
            </div>
          </el-card>
        </div>
        <div v-show="!list || list.length == 0" class="card-item-default">
          <img class="image huger" src="@/assets/empty.png" />
          <div class="font-md mb-hg">暂无数据</div>
        </div>
      </div>
    </div>

    <!-- 新建/编辑项目弹窗 -->
    <PmEdit v-if="editShow" :show.sync="editShow" :projectid="projectid" :way="editWay" @submit="handleEditProject" />
    <!-- 设置分组弹窗 -->
    <PmGroup v-if="groupShow" :show.sync="groupShow" :list="groupList" :selected="activeProject.groupids"
      @change="setProjectToGroup" />
    <!-- 复制项目弹窗 -->
    <PmCopy v-if="copyShow" :show.sync="copyShow" @change="handleCopyProject" />
    <!-- 归档复制项目弹窗 -->
    <PmArchive v-if="archiveShow" :show.sync="archiveShow" :title="activeProject.project_title"
      @change="handleArchiveProject" />
    <!-- 删除项目弹窗 -->
    <PmRecycle v-if="recycleShow" :show.sync="recycleShow" :title="activeProject.project_title"
      @change="handleRecycleProject" />
    <!-- 彻底删除项目弹窗 -->
    <PmRemove v-if="removeShow" :show.sync="removeShow" :title="activeProject.project_title"
      @change="handleRemoveProject" />
  </div>
</template>

<script>
import { getGroupListApi, updateGroupApi, deleteGroupApi, sortGroupApi, joinGroupApi } from '@/api/pm/groupApi'
import { getProjectListApi, createProjectApi, editProjectApi, starProjectApi, archiveProjectApi, recycleProjectApi, removeProjectApi, getArchivedProjectList, getRecycledProjectList, getStarListApi } from '@/api/pm/projectApi'

import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
    CommonMore: () => import('./components/common/CommonMore'),
    TaskPie: () => import('./components/pm/PmTaskPie'),
    PmEdit: () => import('./components/pm/PmEdit'),
    PmGroup: () => import('./components/pm/PmGroup'),
    PmCopy: () => import('./components/pm/PmCopy'),
    PmArchive: () => import('./components/pm/PmArchive'),
    PmRecycle: () => import('./components/pm/PmRecycle'),
    PmRemove: () => import('./components/pm/PmRemove')
  },

  data () {
    return {
      dataLoading: false,
      groupShow: false,
      copyShow: false,
      archiveShow: false,
      recycleShow: false,
      removeShow: false,
      editMenuShow: false,

      editShow: false,
      editWay: 'add', // add || edit
      projectid: '', // 当前表单内容

      activeTab: '', // 左侧工具栏当前tab
      activeTitle: '', // 内容当前标题
      activeCount: 0, // 对应分组（分类）当前数量
      activeView: '', // 当前视图（列表、卡片）
      activeProject: '', // 当前项目
      activeStyleId: null, // 卡片视图下保持选择态样式的项目id

      total: 12,
      list: [],
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: ''
      },

      moreOpts: [
        {
          name: '重命名',
          command: 'rename'
        },
        {
          name: '删除分组',
          command: 'delete',
          type: 'danger'
        }
      ],
      groupList: [],
      indexGroup: {}
    }
  },

  computed: {
    user () {
      return this.$store.state.userStore.user
    },
    activeParam () {
      if (this.activeTab >= -1) {
        return { groupid: Number(this.activeTab) }
      } else {
        return { groupid: null }
      }
    },
    commonConfig () {
      // commonMore组件配置处理
      return function (row) {
        let config = [
          {
            name: '编辑',
            command: 'edit'
          },
          {
            name: '设为星标',
            command: 'star'
          },
          {
            name: '移动到',
            command: 'move'
          },
          // {
          // 	name: '复制到',
          // 	command: 'copy'
          // },
          {
            name: '归档',
            command: 'archive'
          },
          {
            name: '删除',
            command: 'delete',
            type: 'danger'
          }
        ]
        config.forEach(item => {
          if (row.star && item.command == 'star') {
            item.name = '取消星标'
          }
        })
        if (this.activeTab == 'recycle') {
          config = [
            {
              name: '恢复项目',
              command: 'delete'
            },
            {
              name: '彻底删除项目',
              command: 'remove',
              type: 'danger'
            }
          ]
        } else if (this.activeTab != 'recycle' && this.activeView == 'card') {
          config = config.filter(v => v.command != 'star')
        }
        return config
      }
    }
  },

  created () {
    this.activeView = localStorage.getItem('__PROJECT_VIEW__') || 'list'
    this.activeTab = localStorage.getItem('__ACTIVE_TAB__') || 'all'
    this.activeTitle = localStorage.getItem('__ACTIVE_TITLE__') || '全部项目'
    this.query = JSON.parse(localStorage.getItem('__PROJECT_QUERY__')) || {
      keyword: '',
      pindex: 1,
      psize: 10
    }
  },

  mounted () {
    this.fetchGroupData()
    this.fetchProjectList()

    window.addEventListener('message', function (e) {
      // iframe通信
    })
    window.onclick = () => {
      this.initActiveStyleId()
    }
  },

  methods: {
    fetchGroupData () {
      getGroupListApi().then(res => {
        if (!res.errno) {
          this.groupList = res.data.list.filter(v => v.groupid)
          this.indexGroup = res.data.list.filter(v => !v.groupid)[0]
        } else {
          this.$message.error(res.message)
        }
      })
    },

    async fetchProjectList (noloading) {
      if (!noloading) this.dataLoading = true
      let tmp = Object.assign({}, this.query, this.activeParam)
      localStorage.setItem('__PROJECT_QUERY__', JSON.stringify(this.query))
      let res
      if (this.activeTab == 'star') {
        res = await getStarListApi(tmp)
      } else if (this.activeTab == 'archive') {
        res = await getArchivedProjectList(tmp)
      } else if (this.activeTab == 'recycle') {
        res = await getRecycledProjectList(tmp)
      } else {
        res = await getProjectListApi(tmp)
      }
      if (!noloading) this.dataLoading = false
      if (!res.errno) {
        this.list = res.data.list
        this.activeCount = res.data.total
        this.total = res.data.total || 0
      } else {
        this.$message.error(res.message)
      }

    },

    handleKeywordChange (e) {
      this.query.keyword = e
      this.fetchProjectList(true)
    },

    /** 左侧菜单切换 */
    switchTab (e) {
      if (e && e.groupid != undefined) {
        this.activeTab = e.groupid
        this.activeTitle = e.name
      } else {
        this.activeTab = e
        if (e == 'star') {
          this.activeTitle = '星标项目'
        } else if (e == 'archive') {
          this.activeTitle = '归档项目'
        } else if (e == 'recycle') {
          this.activeTitle = '项目回收站'
        } else if (e == 'all') {
          this.activeTitle = '全部项目'
        }
      }
      localStorage.setItem('__ACTIVE_TAB__', this.activeTab)
      localStorage.setItem('__ACTIVE_TITLE__', this.activeTitle)
      this.fetchProjectList()
    },

    /** 视图切换 */
    switchView (e) {
      this.activeView = e
      localStorage.setItem('__PROJECT_VIEW__', e)
    },

    toProjectDetail (row, tab) {
      let _tab = 'task'
      if (tab) _tab = tab
      this.$router.push('/pm/detail?id=' + row.projectid + '&tab=' + _tab)
    },

    /** 活跃样式处理 */
    initActiveStyleId () {
      if (this.activeStyleId) this.activeStyleId = null
    },
    setActiveStyleId (id) {
      this.activeStyleId = id
    },

    setMessageToF () {
      var parentData = { type: 'passDataBack', data: '1111111' }
      window.parent.postMessage(parentData, '*')
    },

    /** 左侧菜单中【更多】全局组件回调处理 */
    handleMenuMoreChange (group, e) {
      if (e == 'rename') {
        this.renameGroup(group)
      } else if (e == 'delete') {
        this.deleteGroup(group)
      }
    },

    /** 表格视图中【更多】全局组件回调处理 */
    handleMoreChange (row, e) {
      if (e == 'edit') {
        this.editProject(row)
      } else if (e == 'star') {
        this.starProject(row)
      } else if (e == 'move') {
        this.moveProject(row)
      } else if (e == 'copy') {
        this.copyProject(row)
      } else if (e == 'archive') {
        this.archiveProject(row)
      } else if (e == 'delete') {
        this.delProject(row)
      } else if (e == 'remove') {
        this.removeProject(row)
      }
    },
    starProject (row) {
      let params = {
        projectid: row.projectid,
        act: row.star ? 0 : 1
      }
      starProjectApi(params).then(res => {
        if (!res.errno) {
          this.fetchProjectList(true)
          row.star ? this.$message.success('取消星标成功！') : this.$message.success('星标操作成功！')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    moveProject (row) {
      this.activeProject = row
      this.groupShow = true
    },
    copyProject (row) {
      this.copyShow = true
    },
    archiveProject (row) {
      this.activeProject = row
      this.archiveShow = true
    },
    delProject (row) {
      if (row.is_delete) {
        // 在回收站中
        this.activeProject = row
        this.$confirm(`恢复项目后，项目即可正常使用。确定恢复？`, '恢复项目', {
          closeOnClickModal: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.handleRecycleProject()
          })
          .catch(() => { })
      } else {
        // 不在回收站中
        this.activeProject = row
        this.recycleShow = true
      }
    },
    removeProject (row) {
      this.activeProject = row
      this.removeShow = true
    },

    /** 新建、编辑项目处理 */
    handleAddProjectShow () {
      this.editWay = 'add'
      this.projectid = null
      this.editShow = true
    },
    editProject (row) {
      this.projectid = row.projectid
      this.editWay = 'edit'
      this.editShow = true
    },
    handleEditProject (form) {
      let params = Object.assign({}, form, this.activeParam)
      if (form.projectid) {
        editProjectApi(params).then(res => {
          if (!res.errno) {
            this.fetchProjectList()
            this.$message.success('编辑项目成功！')
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        createProjectApi(params).then(res => {
          if (!res.errno) {
            this.fetchProjectList()
            this.$message.success('新建项目成功！')
          } else {
            this.$message.error(res.message)
          }
        })
      }



    },

    /** 复制项目处理 */
    handleCopyProject (e) {
      // console.log(e)
    },

    /** 归档项目处理 */
    handleArchiveProject () {
      let params = {
        projectid: this.activeProject.projectid,
        act: this.activeProject.archived ? 0 : 1
      }
      archiveProjectApi(params).then(res => {
        if (!res.errno) {
          this.fetchProjectList(true)
          this.activeProject.archived ? this.$message.success('项目已恢复成功！') : this.$message.success('项目归档成功！')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    recoverProject (item) {
      this.activeProject = item
      this.$confirm(`恢复项目后，项目即可正常使用。确定恢复？`, '恢复项目', {
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.handleArchiveProject()
        })
        .catch(() => { })
    },

    /** 删除项目处理（移至回收站） */
    handleRecycleProject () {
      let params = {
        projectid: this.activeProject.projectid,
        act: this.activeProject.is_delete ? 0 : 1
      }
      recycleProjectApi(params).then(res => {
        if (!res.errno) {
          this.fetchProjectList(true)
          this.activeProject.is_delete ? this.$message.success('项目已恢复成功！') : this.$message.success('项目已移至回收站！')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 彻底删除项目 */
    handleRemoveProject () {
      removeProjectApi({ projectid: this.activeProject.projectid }).then(res => {
        if (!res.errno) {
          this.fetchProjectList(true)
          this.$message.warning('项目已彻底删除！')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 分组操作处理 */
    showAddGroup () {
      this.$prompt('分组名称', '新建项目分组', {
        confirmButtonText: '立即创建',
        cancelButtonText: '取消',
        closeOnClickModal: false
      })
        .then(({ value }) => {
          updateGroupApi({ name: value }).then(res => {
            if (!res.errno) {
              this.fetchGroupData()
              this.$message.success('新增分组成功！')
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => { })
    },
    renameGroup (group) {
      this.$prompt('分组名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: group.name,
        closeOnClickModal: false
      })
        .then(({ value }) => {
          updateGroupApi({ groupid: group.groupid, name: value }).then(res => {
            if (!res.errno) {
              this.fetchGroupData()
              this.$message.success('修改成功！')
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => { })
    },
    handleDraggableChange (e) {
      let groupids = this.groupList.map(v => v.groupid)
      sortGroupApi({ groupids }).then(res => {
        if (!res.errno) {
          this.$message.success('操作成功！')
        } else {
          this.fetchGroupData()
          this.$message.error(res.message)
        }
      })
    },
    deleteGroup (group) {
      this.$confirm(`确定删除项目分组<span class="text-danger">【${group.name}】</span>吗？`, '删除项目分组', {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-danger-class'
      })
        .then(() => {
          deleteGroupApi({ groupid: group.groupid }).then(res => {
            if (!res.errno) {
              if (this.activeTab == group.groupid) {
                this.switchTab('all')
                this.fetchProjectList()
              }
              this.fetchGroupData()
              this.$message.success('操作成功！')
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => { })
    },
    setProjectToGroup (list) {
      joinGroupApi({ projectid: this.activeProject.projectid, groupids: list }).then(res => {
        if (!res.errno) {
          (this.activeTab == 0 || this.activeTab) && this.fetchProjectList() // 需刷新
          this.$message.success('设置分组成功！')
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss">
$--pm-list-menu-categroy-color: #111317;
$--pm-list-menu-border-color: #e7e7e7;
$--pm-list-menu-item-hover-color: #f5f7f9;
$--pm-list-menu-item-active-color: #07c160;
$--pm-list-menu-item-active-bg: #f0f3f5;
$--pm-list-menu-add-btn-color: #8c939f;

.pm-list {
  .pm-list-menu {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 239px;
    padding: 0 12px;
    border-right: 1px solid $--pm-list-menu-border-color;
    background-color: #fff;

    >.menu-content {
      height: 222px;

      .category-title {
        line-height: 24px;
        font-size: 16px;
        padding: 24px 16px 13px 12px;
        color: $--pm-list-menu-categroy-color;
      }
    }

    >.group-content {
      width: calc(100% + 6px);
      height: calc(100% - 222px);
      padding-right: 6px;
      overflow-y: hidden;

      .index {
        height: 36px;
        line-height: 36px;
        padding-left: 35px;
        padding-right: 8px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: $--pm-list-menu-categroy-color;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
          background-color: $--pm-list-menu-item-hover-color;
        }
      }

      .group-list {
        width: calc(100% + 6px);
        max-height: calc(100% - 74px);
        overflow-x: hidden;
        overflow-y: scroll;

        .item {
          padding-left: 35px;
          height: 32px;
          line-height: 32px;
          position: relative;

          .move-icon {
            position: absolute;
            top: 50%;
            left: 10px;
            transform: translateY(-50%);
            display: none;
            cursor: move;
          }

          &:hover {
            .more {
              display: inline-block;
            }

            .move-icon {
              display: inline-block;
            }
          }
        }
      }

      .add-btn {
        margin: 3px 0;
        padding-left: 35px;
        padding-right: 8px;
        cursor: pointer;
        color: $--pm-list-menu-add-btn-color;
        font-size: 12px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        position: sticky;
        bottom: 0;
        background-color: #fff;

        .icon {
          margin-right: 8px;
        }

        &:hover {
          background-color: $--pm-list-menu-item-hover-color;
        }
      }

      .active {
        background: $--pm-list-menu-item-active-bg;
        color: $--pm-list-menu-item-active-color;
      }
    }

    .category-list,
    .group-list {
      .item {
        height: 36px;
        line-height: 36px;
        padding-right: 8px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: $--pm-list-menu-categroy-color;
        cursor: pointer;
        border-radius: 4px;

        .icon {
          width: 16px;
          margin-right: 8px;
          margin-left: 12px;
        }

        .name {
          flex: 1;
        }

        &:hover {
          background-color: $--pm-list-menu-item-hover-color;
        }
      }

      .item-all {
        margin-top: 17px;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: -9px;
          height: 1px;
          background: #f3f3f3;
        }
      }

      .active {
        background: $--pm-list-menu-item-active-bg;
        color: $--pm-list-menu-item-active-color;
      }
    }
  }

  .pm-list-container {
    padding: 72px 0 20px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 240px;
    right: 0;
    overflow: hidden;
    background-color: #f8f8fa;

    .container-header {
      font-size: 18px;
      width: 100%;
      height: 72px;
      display: flex;
      align-items: center;
      position: absolute;
      padding-left: 20px;
      top: 0;
      left: 0;
      background-color: #fff;
    }

    .container-toolbox {
      width: 100%;
      margin: 15px 0;
      padding: 0 20px;
      box-sizing: border-box;

      .info-class {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        background-color: #e6e9ed;

        &.warning {
          background-color: #fef5e6;
        }
      }

      .view-switch {
        display: flex;
        border-radius: 10%;
        font-size: 26px;
        background-color: #fff;

        .btn {
          width: 40px;
          height: 40px;
        }

        .active {
          color: $--pm-list-menu-item-active-color;
        }
      }
    }

    .list-container {
      margin: 0 20px;
      width: calc(100% - 40px);
      height: calc(100% - 70px);
      padding-bottom: 52px;
      box-sizing: border-box;

      >.el-card__body {
        height: 100%;

        .pm-list-table {
          width: 100%;
          box-sizing: content-box;
          border-bottom: 1px solid #ebeef5;

          .el-table__body {
            .el-table__row {
              &:hover {
                .project-title {
                  .more {
                    display: inline-block;
                  }

                  .common-icon-hover {
                    display: flex;
                  }
                }
              }
            }

            .current-row>td {
              background-color: #f5f7fa;
            }

            .current-row {
              .project-title {
                .more {
                  display: inline-block;
                }

                .common-icon-hover {
                  display: flex;
                }
              }
            }
          }

          .project-title {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .common-icon-hover {
              display: none;
            }
          }
        }

        .table-footer {
          display: block;
          padding: 20px 0;
          line-height: 26px;
        }
      }
    }

    .card-container {
      max-width: 2200px;
      max-height: 100%;
      padding: 0 5px 60px;
      margin: 0 auto;
      overflow-y: scroll;

      .card-item-container {
        @media (max-width: 2000px) {
          width: 25%;
        }

        @media (max-width: 1800px) {
          width: 33.3%;
        }

        width: 20%;
        min-width: 360px;
        float: left;
        display: flex;

        .card-item {
          flex: 1;
          margin: 0 15px 15px;
          width: 100%;
          height: 245px;
          cursor: pointer;

          .el-card__body {
            padding: 15px 20px 10px;

            .task-item {
              width: 115px;
            }

            .fast-icon {
              display: flex;
              align-items: center;

              .item {
                padding: 5px;
                border-radius: 50%;
                border: 1px solid $--pm-list-menu-border-color;
                display: none;
                align-items: center;
                justify-content: center;

                >img {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }

          &:hover {
            .fast-icon {
              .item {
                display: flex;
              }
            }

            .more {
              display: inline-block;
            }

            .common-icon-hover {
              display: inline-block;
            }
          }
        }

        .item-selected {
          .more {
            display: inline-block;
          }

          .common-icon-hover {
            display: inline-block;
          }
        }
      }

      .card-item-default {
        min-height: 500px;
        margin: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.confirm-danger-class {
  border: 1px solid #f56c6c !important;
  background-color: #f56c6c !important;

  &:hover {
    border: 1px solid #f78989 !important;
    background-color: #f78989 !important;
  }
}
</style>